const existing_items = document.querySelectorAll(".editor-content > *");
const number_of_existing_items = existing_items.length;

const new_items = document.querySelectorAll(".post-related");
const number_of_new_items = new_items.length;

// If there are multiple existing items and any new items to insert, then insert them
if (number_of_existing_items > 1 && number_of_new_items > 0) {
	// Calculate how often an item should be inserted
	const spacing = number_of_existing_items / number_of_new_items;
	for (let i = 0; i < number_of_new_items; i++) {
		let position = spacing * (i + 1);
		position = position - Math.ceil(spacing / 2); // Shift the insertion point back half the spacing amount so they end up distributed in the middle of the range
		position = position - 1; // Shift the insertion point back by 1 because we insert it using .after()
		// console.table({ i: i, position: position, spacing: spacing });
		position = Math.ceil(position); // Round the insertion point

		if (new_items[i]) {
			existing_items[position].after(new_items[i]);
		}
	}
}
